"use client";
import React from "react";
import styles from "./Home.module.scss";
import ChatBody from "../chat/ChatBody";
import SidebarContent from "../robot/components/sidebarContent";
import RouteParamsHandler from "@/app/bridge/RouteParamsHandler.optimized";
import AClickListener from "@/app/lib/AClickListener";
import { useCurrentLocale } from "@/app/lib/LocaleProvider";
import { isHandyApp } from "@/app/utils/device";
import AIProtocolModal from "@/app/components/aiProtocolModal";
// import ResetUrlModalWrapper from "@/app/components/resetUrlModal";

interface HomeProps {
  source?: string;
}

export default function Home({ source }: HomeProps = {}) {
  const locale = useCurrentLocale();
  const isHandy = isHandyApp();

  // 可以根据 source 做不同的处理
  // React.useEffect(() => {
  //   if (source) {
  //     console.log("Page source:", source);
  //     // 这里可以添加数据上报、统计等逻辑
  //   }
  // }, [source]);
  return (
    <div className={styles.container}>
      <AClickListener />
      {/* <ResetUrlModalWrapper /> */}
      <AIProtocolModal />
      <div className={styles.mainLayout}>
        {/* 左侧聊天区 */}
        <div className={styles.chatPanel}>
          <SidebarContent />
          <div className={styles.chatContainer}>
            {isHandy ? (
              <RouteParamsHandler lng={locale}>
                <ChatBody />
              </RouteParamsHandler>
            ) : (
              <ChatBody />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
